<template>
  <b-nav-item :to="$store.getters.userIsGMAdmin ? '/admin' : '/mss-admin'">
    <cog-icon class="icon-cog" />
  </b-nav-item>
</template>

<script>
import CogIcon from 'vue-material-design-icons/Cog';

export default {
  name: 'AdminNavMenuItems',
  components: {
    CogIcon,
  },
};
</script>

<style scoped></style>
